import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { GalleryService } from '@millionshow/api-client';
import { Icon } from '@millionshow/client-libs';
import { injectParams } from 'ngxtension/inject-params';
import { of } from 'rxjs';
import { SeoService } from '../../../../services/seo.service';

import { GalleryVideoPlayer } from '@millionshow/client-libs';

@Component({
  selector: 'app-gallery-detail',
  imports: [GalleryVideoPlayer, CommonModule, RouterLink, Icon],
  templateUrl: './gallery-detail.page.html',
})
export default class GalleryDetailPage {
  private readonly galleryService = inject<GalleryService>(GalleryService);
  private readonly seoService = inject(SeoService);

  readonly id = injectParams('id');

  selectedImage = signal<string | null>(null);

  constructor() {
    effect(() => {
      const data = this.data();

      if (!data) return;

      const isVideo = data.type === 'VIDEO';

      this.seoService.set({
        title:
          data.title || (isVideo ? '영상 갤러리 상세' : '사진 갤러리 상세'),
        description: `${data.title || '밀리언쇼'} ${
          isVideo ? '영상' : '사진'
        } 갤러리 상세 페이지입니다.`,
        path: `/gallery/${
          isVideo ? 'video-gallery' : 'photo-gallery'
        }/${this.id()}`,
        image: data.photos?.[0] || undefined,
      });
    });
  }

  $data = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.galleryService.galleryControllerFindByIdV1({ id: params.id })
        : of(null),
  });

  readonly data = computed(() => this.$data.value());

  $adjacentGalleries = rxResource({
    params: () => ({ id: this.id() }),
    stream: ({ params }) =>
      params.id
        ? this.galleryService.galleryControllerFindAdjacentV1({
            id: params.id,
          })
        : of(null),
  });

  prevGallery = computed(() => this.$adjacentGalleries.value()?.prev ?? null);
  nextGallery = computed(() => this.$adjacentGalleries.value()?.next ?? null);

  getTypeLabel(type: string): string {
    return type === 'VIDEO' ? '동영상' : '사진';
  }

  openImageModal(photo: string): void {
    this.selectedImage.set(photo);
  }

  closeImageModal(): void {
    this.selectedImage.set(null);
  }
}
